// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e0b05814","703":"48a77dd2","787":"496e900f"}[chunkId] + ".chunk.js";
};